import { render, staticRenderFns } from "./BirthdaySampleUpdate.vue?vue&type=template&id=0973e09b&scoped=true"
import script from "./BirthdaySampleUpdate.vue?vue&type=script&lang=js"
export * from "./BirthdaySampleUpdate.vue?vue&type=script&lang=js"
import style0 from "./BirthdaySampleUpdate.vue?vue&type=style&index=0&id=0973e09b&lang=css"
import style1 from "./BirthdaySampleUpdate.vue?vue&type=style&index=1&id=0973e09b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0973e09b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0973e09b')) {
      api.createRecord('0973e09b', component.options)
    } else {
      api.reload('0973e09b', component.options)
    }
    module.hot.accept("./BirthdaySampleUpdate.vue?vue&type=template&id=0973e09b&scoped=true", function () {
      api.rerender('0973e09b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/BirthdaySampleUpdate.vue"
export default component.exports